import React from "react";
import PropTypes from "prop-types";
import CopyToClipboard from "react-copy-to-clipboard";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";

import Button from "Components/button/Button";
import Input from "Components/input/Input";
import cx from "classnames";
import s from "./apiTokenGenerator.scss";

const propTypes = {
  token: PropTypes.string,
  generate: PropTypes.func,
  destroy: PropTypes.func,
  loading: PropTypes.bool,
  resetting: PropTypes.bool
};

export default class ApiTokenGenerator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false
    };
  }

  destroy() {
    this.setState({ copied: false });
    this.props.destroy();
  }

  // renderCopyButton() {
  //   return (
  //     <CopyToClipboard text={this.props.token || ""} onCopy={() => this.setState({ copied: true })}>
  //       <Button className={s.btnCopy} disabled={this.state.copied}>
  //         button.copy
  //       </Button>
  //     </CopyToClipboard>
  //   );
  // }

  render() {
    let { className, token, loading, generate, resetting } = this.props;
    let button;

    if (loading) {
      token = t("input.placeholder.token.generation");
    } else {
      if (token) {
        button = (
          <Button className={s.btn} color="outline" type="button" onClick={this.destroy.bind(this)}>
            button.reset.token
          </Button>
        );
      } else {
        button = (
          <Button className={s.btn} color="outline" type="button" onClick={generate}>
            button.generate.token
          </Button>
        );
        token = "";
      }
    }

    if (resetting) {
      token = t("input.placeholder.token.reset");
    }

    return (
      <div className={cx(className, s.apiToken)}>
        <div className={s.wrapBtn}>
          {button}
          {this.state.copied && <div className={s.copiedMsg}>{t("infoMsg.token.copied")}</div>}
        </div>
        <div className={s.wrapInput}>
          <Input type="text" id="repeater" readOnly value={token} />

          {/*<input
            className={cx(s.input, { [s.disabled]: true })}
            type="text"
            id="repeater"
            readOnly
            value={token}
          />
          */}
          <CopyToClipboard
            text={this.props.token || ""}
            onCopy={() => this.setState({ copied: true })}
          >
            <Button className={s.btnCopy} disabled={this.state.copied}>
              button.copy
            </Button>
          </CopyToClipboard>
        </div>
      </div>
    );
  }
}
